import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=13175cac&scoped=true&"
import script from "./EditBrand.vue?vue&type=script&lang=js&"
export * from "./EditBrand.vue?vue&type=script&lang=js&"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=13175cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13175cac",
  null
  
)

export default component.exports